<script>
    import * as Collapsible from '@/components/ui/collapsible/index.js';
    import * as Card from '@/components/ui/card';
    import { Button } from '@/components/ui/button/index.js';
    import { ChevronDownIcon, ChevronsUpDownIcon, ChevronUpIcon } from 'lucide-svelte';
    import Debug from '@/components/Debug.svelte';
    import { Badge } from '@/components/ui/badge/index.js';
    import BlockTitle from '@/components/Form/BlockTitle.svelte';
    import { cn } from '@/lib/utils';

    let {
        label='',
        labelClass = '',
        headerIcon = null,
        buttons = null,
        children,
        hasErrors = false,
        count = null,
        collapsible = false,
        defaultOpen = true,
        cols=2,
        ...args
    } = $props();

    let open = $state(defaultOpen);
</script>

<Card.Root class={args.class + " mb-4"}>
    {#if collapsible}
        <Collapsible.Root bind:open>
            <Card.Header>
                <Card.Title class="flex w-full items-center gap-2">
                    <Collapsible.Trigger class="flex items-center gap-2">
                        {#if label}
                            <span class={labelClass}>{label}</span>
                        {/if}
                        <ChevronUpIcon
                            class={cn(!open ? 'rotate-180' : '', 'transition-transform')}
                        />
                        {#if headerIcon}{@render headerIcon()}{/if}
                        <span class="sr-only">Toggle</span>
                    </Collapsible.Trigger>
                    {#if buttons}
                        <div class="ml-auto flex gap-2">
                            {@render buttons()}
                        </div>
                    {/if}
                </Card.Title>
            </Card.Header>
            <Card.Content>
                <Collapsible.Content  class="grid grid-cols-1 gap-4 md:grid-cols-{cols}">
                    {@render children?.()}
                </Collapsible.Content>
            </Card.Content>
        </Collapsible.Root>
    {:else}
        <Card.Header>
            <Card.Title class="flex w-full gap-2 text-lg font-bold">
                {#if headerIcon}{@render headerIcon()}{/if}
                {#if label}
                    <span class={labelClass}>{label}</span>
                {/if}
                {#if count != null}
                    <Badge>{count}</Badge>
                {/if}
                {#if buttons}
                    <div class="ml-auto flex gap-2">
                        {@render buttons()}
                    </div>
                {/if}
            </Card.Title>
        </Card.Header>
        <Card.Content class="grid grid-cols-1 gap-4 md:grid-cols-{cols}">
            {@render children?.()}
        </Card.Content>
    {/if}
</Card.Root>
